import { UseTellescopeQueryOptions } from "../../types";
import { useTellescopeQuery } from "../../use-tellescope-query";
import { FDB_CODING_SYSTEM, type FHIRCoding } from "./use-canvas-medications-query";

export interface FHIRAllergyIntolerance {
  resourceType: string;
  id: string;
  code?: {
    coding?: FHIRCoding[];
  };
}

export interface CanvasAllergiesBundle {
  resourceType: "Bundle";
  type: "searchset";
  total: number;
  link?: {
    relation: string;
    url: string;
  }[];
  entry?: {
    resource: FHIRAllergyIntolerance;
  }[];
}

export interface CanvasAllergyOption {
  code: string;
  display: string;
  system: string;
}

export const canvasAllergyOptions = (bundle: CanvasAllergiesBundle | undefined): CanvasAllergyOption[] =>
  (bundle?.entry ?? []).reduce<CanvasAllergyOption[]>(
    (options, entry) =>
      (entry?.resource?.code?.coding ?? []).reduce(
        (acc, coding) =>
          coding.system?.includes(FDB_CODING_SYSTEM)
            ? [...acc, { code: coding.code, display: coding.display, system: coding.system }]
            : acc,
        options
      ),
    []
  );

export interface UseCanvasAllergiesQueryOptions<TError = Error, TData = { data: CanvasAllergiesBundle }>
  extends Omit<UseTellescopeQueryOptions<"integrations", "proxy_read", TError, TData>, "model" | "method" | "request"> {
  query: string | undefined;
}

export const useCanvasAllergiesQuery = <TError = Error, TData = { data: CanvasAllergiesBundle }>({
  query,
  enabled,
  ...options
}: UseCanvasAllergiesQueryOptions<TError, TData>) =>
  useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: { integration: "Canvas", type: "allergies", query: query ?? "" },
    enabled: !!query && (enabled ?? true),
    ...options,
  });
